// extracted by mini-css-extract-plugin
export default {"dialog":"styles_dialog__pZhNk","dialogBody":"styles_dialogBody__FBuQY"};